import React, {useContext, useEffect, useState} from 'react'
import {Form, InputNumber} from "antd";
import {RecipeConText} from "../../../../../context/RecipeContext";

const RecipeItemPrice = ({rowId}) => {
    const [form] = Form.useForm()
    const [price, setPrice] = useState(0)
    const {rowData} = useContext(RecipeConText)
    const [rowState, setRowState] = rowData

    useEffect(() => {
        if (rowState[rowId].data){
            setPrice(rowState[rowId].data.price)
            form.setFieldsValue({stockPrice: price})
        }
    })

    const handlePriceChange = () => {
        const {
            stockPrice
        } = form.getFieldsValue()
        let mockRow = Object.assign({}, rowState)
        mockRow[rowId].data.price = stockPrice
        setRowState(mockRow)
    }

    return(
        <React.Fragment>
            <Form
                form={form}
                wrapperCol={{span: 16}}
            >
                <Form.Item name={'stockPrice'}>
                    <InputNumber
                        onChange={handlePriceChange}
                        min={0}
                        step={0.1}
                    />
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default RecipeItemPrice